export const FIELD_MAPPINGS = {
  name: ['name', 'full name', 'fullname', 'delegate name', 'attendee name', 'first name', 'firstname'],
  first_name: ['first name', 'firstname', 'first', 'given name'],
  last_name: ['last name', 'lastname', 'last', 'surname', 'family name'],
  email: ['email', 'email address', 'e-mail', 'mail'],
  phone: ['phone', 'phone number', 'telephone', 'mobile', 'cell', 'contact number'],
  company: ['company', 'organization', 'organisation', 'org', 'employer', 'institution'],
  title: ['title', 'job title', 'position', 'designation', 'role'],
  tier: ['tier', 'category', 'type', 'delegate type', 'registration type', 'ticket type'],
  gender: ['gender', 'sex'],
  province: ['province', 'state', 'region'],
  district: ['district', 'area', 'zone'],
  date_of_birth: ['date of birth', 'dob', 'birth date', 'birthday', 'date_of_birth'],
  age_group: ['age group', 'age_group', 'age range', 'age category'],
  country: ['country', 'nation', 'nationality'],
  city: ['city', 'town'],
  dietary: ['dietary', 'dietary requirements', 'food preferences', 'diet'],
  housing: ['housing', 'accommodation', 'housing required', 'needs housing'],
  meal_access: ['meal access', 'meal_access', 'meals', 'meal entitlement'],
  accommodation_access: ['accommodation access', 'accommodation_access', 'housing access'],
  session_access: ['session access', 'session_access'],
  vip_access: ['vip access', 'vip_access', 'vip'],
  lounge_access: ['lounge access', 'lounge_access'],
  payment_status: ['payment status', 'payment_status', 'paid', 'payment'],
  notes: ['notes', 'comments', 'remarks', 'additional info'],
};

export const TEMPLATE_FIELDS = [
  { key: 'first_name', label: 'First Name', required: true, example: 'John' },
  { key: 'last_name', label: 'Last Name', required: true, example: 'Smith' },
  { key: 'email', label: 'Email', required: false, example: 'john@example.com' },
  { key: 'phone', label: 'Phone', required: false, example: '+1234567890' },
  { key: 'province', label: 'Province', required: false, example: 'Midlands' },
  { key: 'district', label: 'District', required: false, example: 'Gweru' },
  { key: 'date_of_birth', label: 'Date of Birth', required: false, example: '2000-05-15' },
  { key: 'age_group', label: 'Age Group', required: false, example: '19-25' },
  { key: 'company', label: 'Company/Organization', required: false, example: 'Acme Corp' },
  { key: 'title', label: 'Title/Position', required: false, example: 'Manager' },
  { key: 'gender', label: 'Gender', required: false, example: 'Male/Female' },
  { key: 'meal_access', label: 'Meal Access', required: false, example: 'yes/no' },
  { key: 'accommodation_access', label: 'Accommodation Access', required: false, example: 'yes/no' },
  { key: 'session_access', label: 'Session Access', required: false, example: 'yes/no' },
  { key: 'vip_access', label: 'VIP Access', required: false, example: 'yes/no' },
  { key: 'lounge_access', label: 'Lounge Access', required: false, example: 'yes/no' },
  { key: 'payment_status', label: 'Payment Status', required: false, example: 'paid/pending' },
  { key: 'notes', label: 'Notes', required: false, example: 'Special request' },
];
